import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './Components/Auth/AuthContext'; // وارد کردن AuthProvider

import { router } from './routes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
    <AuthProvider>    
      <RouterProvider router={router} />
    </AuthProvider>
 
);

reportWebVitals();